import { Leaf, HeartHandshake, Home, Award } from "lucide-react";
import { Reveal } from "./Reveal";

const FEATURES = [
    { icon: Leaf, title: "علاجات طبيعية", testid: "feature-natural" },
    { icon: HeartHandshake, title: "اهتمام شخصي", testid: "feature-personal" },
    { icon: Home, title: "مساحة دافئة وآمنة", testid: "feature-safe" },
];

export const About = ({ onOpenCertificates }) => (
    <section
        id="about"
        data-testid="about-section"
        className="scroll-mt-24 bg-white py-16 lg:py-24"
    >
        <div className="mx-auto max-w-3xl px-5 lg:px-10">
            <Reveal>
                <p className="mb-3 text-sm font-bold text-miam-rose">
                    تعرّفي عليّ
                </p>
                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-miam-dark">
                    أنا <span className="italic text-miam-rose">مياسة</span>
                </h2>
                <p className="mt-6 text-base md:text-lg font-medium text-miam-dark/90 leading-relaxed">
                    رحلة لطيفة نحو الراحة، التوازن والاهتمام بجسدك، من خلال
                    علاجات طبيعية وتجربة شخصية تراعي احتياجاتك.
                </p>
                <p className="mt-5 text-base text-miam-muted leading-loose">
                    أنا مياسة، أخصائية أعشاب وعلاج بالتغذية الطبيعية. أرافق
                    النساء في رحلة شفاء لطيفة وعميقة، تجمع بين الاهتمام بالجسد،
                    الإصغاء لاحتياجاته، والبحث عن التوازن الداخلي.
                </p>
                <p className="mt-4 text-base text-miam-muted leading-loose">
                    في ميام أقدّم مجموعة من العلاجات الطبيعية والجسدية في مساحة
                    دافئة وآمنة، لأساعدك على منح جسدك وقتاً للراحة، ولروحك مساحة
                    من الهدوء والاحتواء.
                </p>
                <button
                    type="button"
                    onClick={onOpenCertificates}
                    data-testid="hero-certificates-button"
                    className="mt-8 inline-flex items-center gap-2 rounded-full bg-miam-green/10 px-7 py-3.5 text-sm font-bold text-miam-green-dark transition-[background-color,color,transform] duration-300 hover:-translate-y-0.5 hover:bg-miam-green hover:text-white"
                >
                    <Award className="h-4 w-4" aria-hidden="true" />
                    شاهدي شهاداتي ودوراتي
                </button>
            </Reveal>

            <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-4">
                {FEATURES.map(({ icon: Icon, title, testid }, i) => (
                    <Reveal key={testid} delay={0.1 * (i + 1)}>
                        <div
                            data-testid={testid}
                            className="flex items-center gap-4 rounded-2xl bg-miam-cream px-6 py-5 soft-shadow-sm transition-[transform,box-shadow] duration-300 hover:-translate-y-1"
                        >
                            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-miam-green/15 text-miam-green-dark">
                                <Icon className="h-6 w-6" aria-hidden="true" />
                            </span>
                            <span className="font-heading text-base font-bold text-miam-dark">
                                {title}
                            </span>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
